export default "__VITE_ASSET__DumiccFV__"